<template>
  <v-container v-if="orgLoading" fluid style="width: 100%; height: 100vh;" class="d-flex align-center justify-center">
    <v-progress-circular indeterminate size="100" width="4" color="primary">
    </v-progress-circular>
  </v-container>

  <v-container v-else fluid>

    <AccountButton v-if="isPadBool">
    </AccountButton>

    <v-row v-if="orgOptions && orgOptions.length > 1">
      <v-col>
        <v-alert dense type="info" class="mb-0">
          {{ $t("text.account_multiple_org_access") }}
          <DirectorySwitcherDialog />
        </v-alert>
      </v-col>
    </v-row>

    <v-row>
      <OrganizationHeader :organization="organization" :loading="orgLoading" />
    </v-row>

    <v-row>
      <v-col :cols="isPhoneBool ? 12 : 6">
        <AccountList>
        </AccountList>
      </v-col>

      <v-col :cols="isPhoneBool ? 12 : 6">
        <ContactList>
        </ContactList>
      </v-col>
    </v-row>

  </v-container>
</template>


<script>
import http from "@/api/client";
import AccountList from "@/components/AccountList.vue";
import ContactList from "@/components/ContactList.vue";
import OrganizationHeader from "@/components/OrganizationHeader.vue";
import DirectorySwitcherDialog from "../../components/Dialogs/DirectorySwitcherDialog.vue";
import AccountButton from "@/components/AccountButton.vue";

export default {
  name: "Organization",
  components: {
    OrganizationHeader,
    ContactList,
    AccountList,
    DirectorySwitcherDialog,
    AccountButton,
  },

  data() {
    return {
      organization: {},
      accounts: [],
      orgLoading: false,
      usersLoading: false,
    };
  },

  mounted() {
    this.getOrg();
  },

  methods: {
    async getOrg() {
      this.orgLoading = true;
      await http()
        .get("api2/customer/userinfo/organization")
        .then((response) => {
          this.organization = response.data;
        });
      this.orgLoading = false;
    },
  },

  computed: {
    orgOptions() {
      console.log("orgOptions", this.$store.state.userInfo.ImpersonationOptions);
      if (this.$store.state.userInfo?.ImpersonationOptions) {
        return this.$store.state.userInfo.ImpersonationOptions;
      } else {
        return [this.$store.state.userInfo.Customer];
      }
    },
  },

  watch: {},
};
</script>

<style>
.expanded {}

.collapsed {
  max-height: 90px;
  overflow-y: hidden;
}
</style>